module.exports = __webpack_public_path__ + "img/рз_53.f896005a.png";